import React, { useEffect } from 'react';
import './App.css';
import { TabLayout } from './components/Layout/TabLayout';
import { CalendarView } from './components/Calendar/CalendarView';
import { DailyView } from './components/Schedule/DailyView';
import { WorkManagement } from './components/Work/WorkManagement';
import { InventoryPage } from './components/Inventory/InventoryPage';
import { ClientList } from './components/Client/ClientList';
import { ToolsPage } from './components/Tools/ToolsPage';
import { MyPage } from './components/My/MyPage';
import { LoginPage } from './components/Auth/LoginPage';
import { useStore } from './stores/useStore';
import { supabase } from './lib/supabase';

function App() {
  const { activeTab, user, isAuthLoading, setUser, setAuthLoading, loadAllData } = useStore();

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
      setAuthLoading(false);
      if (session?.user) loadAllData();
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
      if (session?.user) loadAllData();
    });

    const handleVisibility = () => {
      if (document.visibilityState === 'visible') {
        supabase.auth.getSession().then(({ data: { session } }) => {
          if (session?.user) loadAllData();
        });
      }
    };
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      subscription.unsubscribe();
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isAuthLoading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#d8d0c5',
        maxWidth: '480px',
        margin: '0 auto',
      }}>
        <div style={{ textAlign: 'center', color: '#5a5a5a' }}>
          <p style={{ fontSize: '14px', fontFamily: "'Noto Sans KR', sans-serif" }}>로딩 중...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  const renderContent = () => {
    switch (activeTab) {
      case 'schedule':
        return (
          <div>
            <CalendarView />
            <DailyView />
          </div>
        );
      case 'work':
        return <WorkManagement />;
      case 'inventory':
        return <InventoryPage />;
      case 'client':
        return <ClientList />;
      case 'tools':
        return <ToolsPage />;
      case 'my':
        return <MyPage />;
      default:
        return null;
    }
  };

  return (
    <TabLayout>
      {renderContent()}
    </TabLayout>
  );
}

export default App;
